import _isEmpty from 'lodash/isEmpty';

import { multiCaseGet } from 'libs/format';
import { getSchemeFromValue, HTTP_URI_SCHEME, MAILTO_URI_SCHEME, TEL_URI_SCHEME } from 'libs/urls';

import { BEHAVIOR_EXTERNAL_LINK, BEHAVIOR_INTERNAL_LINK, BEHAVIOR_LABEL } from '../../constants';
import { ensureSlashes, getPageUrl } from '../../utils';

export function getPageForUrl(url, availablePages) {
  if (_isEmpty(url)) {
    return null;
  }

  return availablePages.find((p) => {
    const pageUrl = getPageUrl(p);

    if (pageUrl && getSchemeFromValue(pageUrl)) {
      return pageUrl === url;
    }

    return ensureSlashes(getPageUrl(p)) === ensureSlashes(url);
  });
}

export function getDropdownText(behavior, url, availablePages) {
  const page = getPageForUrl(url, availablePages);

  if (behavior === BEHAVIOR_INTERNAL_LINK) {
    if (!page) {
      return '';
    }

    const pageTitle = multiCaseGet(page, 'title') || multiCaseGet(page, 'pageType');
    return pageTitle ? `Visit "${pageTitle}" page` : '';
  }

  if (behavior === BEHAVIOR_EXTERNAL_LINK) {
    let finalUrl = url;

    if (page) {
      finalUrl = getPageUrl(page);
    }

    const scheme = getSchemeFromValue(finalUrl);

    if (scheme === MAILTO_URI_SCHEME) {
      return 'Send email';
    }

    if (scheme === TEL_URI_SCHEME) {
      return 'Call';
    }

    if (scheme === HTTP_URI_SCHEME) {
      return 'Visit page';
    }
  }

  return BEHAVIOR_LABEL[behavior] || behavior;
}
